import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ApiService, requiredFileType, requiredFileSize, markAllAsDirty, toFormData } from 'src/app/_services/api.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
    selector: 'app-contactSpeaker',
    templateUrl: './contactSpeaker.component.html',
    styleUrls: ['./contactSpeaker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactSpeakerComponent implements OnInit {
  progress = 0;
  contactForm: any;
  success = false;
  time: Date = new Date();
  bsConfig: Partial<BsDaterangepickerConfig>;

  constructor( private http: HttpClient, private formBuilder: UntypedFormBuilder, private apiService: ApiService ) {
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-dark-blue'
    })
    this.contactForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      description: '',
      email: ['', Validators.required],
      organization: '',
      title: "",
      number: '',
      direction: '',
      street: '',
      type: '',
      unit: '',
      city: '',
      zipCode: '',
      date: '',
      day: '',
      time: '',
      locationNumber: '',
      locationDirection: '',
      locationStreet: '',
      locationType: '',
      locationUnit: '',
      locationCity: '',
      locationZipCode: '',
      crossStreet: '',
      purpose:'',
      topic: '',
      attendees: '',
      speech: '',
      materials: '',
      certificateRadio: ['',Validators.required],
      introductionBy: '',
      speakers: '',
      attire: '',
      dateContacted: '',
      dateConfirmed: '',
      recaptchaReactive: ['', Validators.required]
    });
    // file: ['', requiredFileType('pdf')],
  }

  submit() {
    this.success = false;
    console.log(this.contactForm)
    if ( !this.contactForm.valid ) {
      markAllAsDirty(this.contactForm);
      return;
    }


    this.apiService.sendForm(toFormData(this.contactForm.value,),'speaker').subscribe(res => {
      // console.log(res);
      this.progress = 0;
      this.success = true;
      this.contactForm.reset();
      console.log(this.contactForm);
    });

  }

  hasError( field: string, error: string ) {
    const control = this.contactForm.get(field);
    if(this.success)
      return false;
    return control.dirty && control.hasError(error);
  }

  ngOnInit() {

  }

}

export class DemoTimepickerPlaceholderComponent {
  hoursPlaceholder = 'hh';
  minutesPlaceholder = 'mm';
}
